export default "__VITE_ASSET__CB408_Jp__"